import React ,{Component} from 'react';
import LockedOutPage from './../../pages/accountLinking/lockedOutPage'

class LockedOut extends Component{

    render(){

        return(

            <div className="Rectangle-100">

            <LockedOutPage/>

            </div>

            );
    }
}

export default LockedOut